module.exports = __webpack_public_path__ + "assets/img/34_878_big.6d6e75ff.jpg";